import { functions } from "../firebase";

// Lead magnets are authored by Claude through the tribed MCP
// (upsert_lead_magnet / publish_lead_magnet) and captured leads flow in
// through the public leadMagnetEvent endpoint. The dashboard only reads, via
// callables (Firestore rules are a stub, so no client SDK reads).

export type LeadMagnetSummary = {
  id: string;
  title: string;
  description?: string;
  type: string;
  buyerStage?: string;
  status: "draft" | "published" | "paused";
  gate?: { mode?: string; collectName?: boolean };
  delivery?: {
    sendEmail?: boolean;
    redirectUrl?: string;
    enrollWelcome?: boolean;
  };
  stats?: {
    views?: number;
    captures?: number;
    emailsDelivered?: number;
    emailOpens?: number;
    emailClicks?: number;
  };
  url: string;
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
};

export type LeadMagnetCapture = {
  email: string;
  name?: string;
  magnetId: string;
  createdAt?: string;
};

export type LeadMagnetDailyStat = {
  day: string;
  views?: number;
  captures?: number;
  emailsDelivered?: number;
  emailOpens?: number;
  emailClicks?: number;
};

export const getLeadMagnets = async (
  communityId: string
): Promise<{ magnets: LeadMagnetSummary[]; slug: string }> => {
  const callable = functions.httpsCallable("getLeadMagnets");
  const result = await callable({ communityId });
  const { magnets, slug } = (result.data || {}) as {
    magnets: LeadMagnetSummary[];
    slug: string;
  };
  return { magnets: magnets ?? [], slug: slug ?? communityId };
};

export const getLeadMagnetLeads = async (
  communityId: string,
  magnetId: string,
  limit = 100
): Promise<{ captures: LeadMagnetCapture[]; daily: LeadMagnetDailyStat[] }> => {
  const callable = functions.httpsCallable("getLeadMagnetLeads");
  const result = await callable({ communityId, magnetId, limit });
  const { captures, daily } = (result.data || {}) as {
    captures: LeadMagnetCapture[];
    daily: LeadMagnetDailyStat[];
  };
  return { captures: captures ?? [], daily: daily ?? [] };
};
